import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { ShowSupportMsg,deleteSupportMsg } from "../../../../context/Slice/EventManagementSlice";
import './Support.css';
import secureLocalStorage from 'react-secure-storage';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router";
import Swal from 'sweetalert2';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
  } from "@mui/material"


const Support = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const Msg = useSelector((state) => state.EventManagementR.Data);
    const [show, setShow] = useState(false);
    const [selectedMsg, setSelectedMsg] = useState(null);

    const token = secureLocalStorage.getItem('token');

    useEffect(() => {
        if (token) {
            try {
                const decoded = jwtDecode(token);
                refreshData();
            } catch (error) {
                console.error("Token decoding failed:", error);
            }
        }
    }, [dispatch, token]);

    const refreshData = () =>{
        dispatch(ShowSupportMsg());
    }

    const handleClose = () => setShow(false);

    console.log(Msg.data)

    const handleShow = (Msg) => {
        setSelectedMsg(Msg);
        setShow(true);
    };

    const handleDelete = (id) => {
        Swal.fire({
          title: 'Are you sure?',
          text: "Delete the user data",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
          customClass: {
            popup: 'swal2-popup'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            dispatch(deleteSupportMsg(id)).then(() => {
                refreshData();
              Swal.fire(
                'Deleted!',
                'The user has been deleted.',
                'success'
              );
            });
          }
        });
      };


   
      const HandleBack = () => {
        navigate("/admin-dashboard");
      };
   
    return (
        <div id="Event-inquiry">
             <Button
                      variant="contained"
                      color="secondary"
                      onClick={HandleBack}
                      sx={{ position: "absolute", top: "20px", left: "20px" }}
                    >
                      Back
                    </Button>
            <div>
                <h2 className="heading">Support Messages</h2>
            </div>
            <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Mobile</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Note</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Msg.data && (
              Msg.data.map((msg, index) => (
                <TableRow key={index}>
                  <TableCell>{msg.fullName || "N/A"}</TableCell>
                  <TableCell>{msg.email || "N/A"}</TableCell>
                  <TableCell>{msg.mobile_number || "N/A"}</TableCell>
                  <TableCell>{msg.type || "N/A"}</TableCell>
                  <TableCell>{msg.note || "N/A"}</TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleShow(msg)}
                    >
                      View
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            ) }
          </TableBody>
        </Table>
      </TableContainer>

      {selectedMsg && (
        <Dialog open={show} onClose={handleClose} fullWidth maxWidth="md">
          <DialogTitle>Message Details</DialogTitle>
          <DialogContent>
            <p><strong>Name:</strong> {selectedMsg.fullName}</p>
            <p><strong>Email:</strong> {selectedMsg.email}</p>
            <p><strong>Mobile:</strong> {selectedMsg.mobile_number}</p>
            <p><strong>Type:</strong> {selectedMsg.type}</p>
            <p><strong>Notes:</strong> {selectedMsg.note}</p>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary" variant="contained">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}
        </div>
    );
};

export default Support;
